import * as globalReducers from './ducks';
import * as reducerRegistry from './ducks/reducerRegistry';
import { createReducerManager } from './reducerManager';

/**
 * Function _createReducer_ builds the root reducer from the global ducks (reducers that are used in
 * multiple pages) plus the page reducers that have registered themselves in `reducerRegistry`.
 *
 * Page ducks are NOT imported here on purpose: they register themselves when their (code-split)
 * module is evaluated, which keeps ~189 KB of page-duck code and its dependencies out of the main
 * bundle. `createReducerManager` picks up late registrations, so a store created before a page duck
 * was loaded still ends up with that page's slice.
 */
const createReducer = () => createReducerManager({ ...globalReducers }, reducerRegistry).reduce;

export default createReducer;
